import http from '@/libs/AxiosPlugin'

const workType = {
  list () {
    return http.get('/workType/list')
    // return new Promise((resolve, reject) => {
    //   let data = [
    //     {id: 1, name: '调机', outputValid: 0, monopoly: 1, maintain: 0, warn: 0, remark: ''},
    //     {id: 2, name: '穿纱', outputValid: 0, monopoly: 0, maintain: 0, warn: 0, remark: ''},
    //     {id: 3, name: '看机', outputValid: 1, monopoly: 1, maintain: 0, warn: 1, remark: ''},
    //     {id: 4, name: '维修', outputValid: 0, monopoly: 1, maintain: 1, warn: 0, remark: ''}
    //   ]
    //   resolve(data)
    // })
  },

  delete (id) {
    return http.post('/workType/delete', {id})
  },

  get (id) {
    return http.post('/workType/get', {id})
  },

  save (wt) {
    return http.post('/workType/save', wt)
  }
}

export default workType



// WEBPACK FOOTER //
// ./src/api/workType.js